import React, { useState } from 'react';
import { Field } from 'formik';
import 'react-simple-keyboard/build/css/index.css';
import Styles from './simpleKeyboard.module.scss';
import KeyboardInput from '../KeyboardInput';
import cn from 'classnames';
import ErrorMessage from '@formElements/ErrorMessage';
import CustomKeyboard from '../../CustomKeyboardCopy/indexRevamp';
import {ReactComponent as Cross} from '@assets/images/cross.svg';
import { flowType } from '@utility/userInfo';

const CustomInputComponent = (props) => {
  const {
    type,
    field,
    customClass,
    placeholder,
    customClassInput,
    haveCurrency = false,
    containerClass,
    form,
    isDot,
    screenType
  } = props;
  const [typed, setTyped] = useState('');
  const isKiosk = flowType() === 'kiosk';

  const getStyle = () => {
    return haveCurrency === '%' ? Styles.currencyPercent : Styles.currencyDollar;
  };
  const onClickBtn = (e) => {
    setTyped(e === '{bksp}' ? typed.slice(0, -1) : typed.concat(e));
    const typedValue = e === '{bksp}' ? typed.slice(0, -1) : typed.concat(e);
    form.setFieldValue(field.name, typedValue);
  };

  const handleClear = () => {
    setTyped('');
    form.setFieldValue(field.name, '');
  };
  return (
    <div className={cn(screenType === 'payAnAmount' ? 'position-relative h-100' : containerClass)}>
      <div className={cn('col-12 p-1 position-relative')} >
        {haveCurrency && <div className={cn('position-absolute', getStyle())} style={{top: '50%', transform:'translateY(-50%)'}}>{haveCurrency}</div>}
        <KeyboardInput
          value={field?.value}
          name={field?.name}
          placeholder={placeholder}
          field={field}
          type="text"
          customClass={customClassInput}
          serverAppTheme={props?.serverAppTheme}
        />
        {/* <ErrorMessage name={field.name} /> */}
        {![0, ''].includes(field.value) && (
          <div
            role="presentation"
            className="position-absolute"
            style={{ right: '10px', top: '16%' }}
            onClick={() => { handleClear(); }}
          >
            <Cross fill={props?.serverAppTheme?.iconcolor} aria-hidden="true" />
          </div>
        )}
      </div>
      <ErrorMessage name={field.name} />
      <div style={{backgroundColor:screenType === 'payAnAmount' ? props?.serverAppTheme?.keyBoard_Bg_Color : 'transparent', bottom:screenType === 'payAnAmount' ? '.4rem' : ''}} className={`${customClass}  ${screenType === 'payAnAmount' ? 'col-12 pl-1 pr-0 pb-1 position-absolute' : 'p-1'}`}>
        <CustomKeyboard
          onClickBtn={(e) => onClickBtn(e)}
          type={type}
          typed={typed}
          isDot={isDot}
          customClass={cn('fs-30px-0 ee', isKiosk && 'fs-40')}
          // goToSwipe={goToSwiper}
          btnSize="btn35"
          screenType={screenType}
        />
      </div>
    </div>
  );
};

const SimpleKeyboard = (props) => {
  const {
    name,
    type,
    customClass,
    customClassInput,
    onChange,
    btnName,
    placeholder,
    goToSwiper,
    isSwipe,
    haveCurrency,
    isDotRequired,
    screenType
  } = props;
  return (
      <Field
        name={name}
        goToSwiper={goToSwiper}
        btnName={btnName}
        placeholder={placeholder}
        component={CustomInputComponent}
        type={type}
        customClass={customClass}
        customClassInput={customClassInput}
        onChange={onChange}
        isSwipe={isSwipe}
        haveCurrency={haveCurrency}
        isDot={isDotRequired}
        screenType={screenType}
        serverAppTheme={props?.serverAppTheme}
      />
  );
};

export default SimpleKeyboard;
